import React, { ChangeEvent, useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import SurveyDetails from "../components/_pages/SurveyDetails";
import EnterSurveyCode from "../components/_pages/EnterSurveyCode";
import Logo from "../images/logo.png";
import { useTranslation } from "react-i18next";
import languageCodes from "../utils/languageCodes";

const AppRouter = () => {
  const { i18n, t } = useTranslation();
  const [preferredLanguage, setPreferredLanguage] = useState(window ? (window.localStorage?.getItem("lng") === "en-GB" ? "en" : window.localStorage?.getItem("lng") || "en") : "en");

  const handleLanguage = () => {
    if (window && window.localStorage) {
      const hasKey = window.localStorage?.getItem("lng");
      if (!hasKey || hasKey === "en-GB") window.localStorage.setItem("lng", i18n.resolvedLanguage === "en-GB" ? "en" : i18n.resolvedLanguage || "en");
    }
  };

  const handleChangeLanuage = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    // Set localStorage to remember preference
    if (window && window.localStorage) {
      if (e.target.name === "preferredLanguage") {
        window && window.localStorage.setItem("lng", e.target.value);
        i18n.changeLanguage(e.target.value);
      }
      setPreferredLanguage(e.target.value);
    } else {
      setPreferredLanguage(e.target.value);
      i18n.changeLanguage(e.target.value);
    }
  };

  useEffect(() => {
    handleLanguage();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <header>
        <div className="color-bar"></div>
        <div className="logo">
          <img src={Logo} alt="The People Experience Hub" />
        </div>
        <div className="row end-xs g-8">
          <select name="preferredLanguage" onChange={handleChangeLanuage} value={preferredLanguage}>
            {languageCodes
              .filter((item) => ["de", "en", "es", "fi", "fr", "it", "nb_NO", "zh", "ro", "ja"].includes(item.id))
              .map((item, i) => (
                <option key={i} value={item.id}>
                  {item.nativeName}
                </option>
              ))}
          </select>
          <button>
            <a href="https://peopleexperiencehub.com" rel="noreferrer" target="_blank">
              {t("general.learnMoreButton")}
            </a>
          </button>
        </div>
      </header>

      <div className="app__container">
        <Router>
          <Routes>
            <Route path="/" element={<EnterSurveyCode />} />
            <Route path="/:surveyCode" element={<SurveyDetails />} />
            <Route path="/*" element={<EnterSurveyCode />} />
          </Routes>
        </Router>
      </div>
    </>
  );
};

export default AppRouter;
